import type { ToolbarDesignTokens } from '@primeuix/themes/types/toolbar';

 export default {
    root: {
        background: "{content.background}",
        borderColor: "{content.border.color}",
        borderRadius: "{border.radius.xl}",
        color: "{content.color}",
        gap: "0.5rem",
        padding: "0.75rem"
    }
} satisfies ToolbarDesignTokens;